import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from "react-helmet-async";
import HeaderFour from '../../components/Header/HeaderFour';
import FooterTwo from '../../components/Footer/FooterTwo';
import { Link } from 'react-router-dom';
import ModalVideo from 'react-modal-video';
import Breadcrumb from '../../components/Breadcrumb';

import serviceImg from '../../assets/img/service/ECommerce-Central-Books.jpg';
import serviceImg2 from '../../assets/img/service/ERP-Centralbooks.jpg';
import serviceImg3 from '../../assets/img/about/customerSupport.jpg';
import Logo from '../../assets/img/logo/logo-white-2.png';


const ItInfra = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(!isOpen);
  };

  return (
    <main>
      <Helmet>
      <title>IT Infrastructure & Technology | CBS HUB Central Books Hyderabad</title>
      <meta name="description" content="CBS HUB's IT infrastructure powers seamless B2B school supply management — from order tracking and inventory to e-commerce and library management for 450+ schools." />
      <meta name="keywords" content="CBS HUB IT infrastructure, Central Books technology, school supply management system, B2B order management Hyderabad education" />
      <link rel="canonical" href="https://www.centralbooks.in/it-and-infra" />
      <meta name="robots" content="index, follow" />
      <meta property="og:title" content="IT Infrastructure & Technology | CBS HUB Central Books Hyderabad" />
      <meta property="og:description" content="CBS HUB's IT infrastructure powers seamless B2B school supply management — from order tracking and inventory to e-commerce and library management for 450+ schools." />
      <meta property="og:url" content="https://www.centralbooks.in/it-and-infra" />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://www.centralbooks.in/images/it-and-infra-og.jpg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="IT Infrastructure & Technology | CBS HUB Central Books Hyderabad" />
      <meta name="twitter:description" content="CBS HUB's IT infrastructure powers seamless B2B school supply management — from order tracking and inventory to e-commerce and library management for 450+ schools." />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://www.centralbooks.in/"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "IT & Infra",
              "item": "https://www.centralbooks.in/it-and-infra"
            }
          ]
        })}
      </script>
    </Helmet>
      <HeaderFour />
      <Breadcrumb title="IT Infrastructure Powering CBS HUB's B2B School Supply Operations" subTitle="IT & Infra" />

      <div className="container pt-60">
        <div className="row justify-content-center text-center mb-40">
          <div className="col-xl-10">
            <h2 className="pb-20" style={{ fontSize: '2.2rem', fontWeight: '700' }}>Order Tracking, Inventory Management & Ecommerce Systems</h2>
            <h3 className="pb-30" style={{ color: '#ea580c', fontSize: '1.6rem', fontWeight: '600' }}>Technology-Driven Institutional Supply for 450+ Schools Across India</h3>
            <p className="lead" style={{ fontSize: '1.25rem', lineHeight: '1.8', color: '#374151' }}>
              CBS HUB Private Limited invests in robust IT infrastructure to ensure reliable, scalable B2B school supply management — including real-time order tracking, inventory systems, e-commerce platforms and library management tools for 450+ schools across India.
            </p>
          </div>
        </div>
      </div>

      <div className="it-sv-details-area pb-30">
        <ModalVideo
          channel="youtube"
          isOpen={isOpen}
          videoId="PO_fBTkoznc"
          onClose={() => openModal()}
        />
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <div className="it-sv-details-top-wrap mb-20">
                <div className="row">
                  <div className="col-xl-4 col-lg-4">
                    <div className="it-sv-details-top-thumb">
                      <img src={serviceImg2} alt="" />
                    </div>
                  </div>
                  <div className="col-xl-8 col-lg-8">
                    <div className="it-sv-details-top-content">
                      <h4 className="it-sv-details-title">Microsoft Dynamics ERP</h4>
                      <p>
                      We are one of the most modern businesses in our sector for use of technology. Our core business information is entirely computerized via our Microsoft Dynamics ERP system hosted on Azure cloud.
                      </p>
                    </div>
                    <div className="it-feature-button">
                                    <Link className="ed-btn-radius" to="#">
                                    Know More..
                                    </Link>
                                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="it-sv-details-area pt-30 pb-30">
        <ModalVideo
          channel="youtube"
          isOpen={isOpen}
          videoId="PO_fBTkoznc"
          onClose={() => openModal()}
        />
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <div className="it-sv-details-top-wrap mb-20">
                <div className="row">
                  <div className="col-xl-4 col-lg-4">
                    <div className="it-sv-details-top-thumb">
                      <img src={serviceImg} alt="" />
                    </div>
                  </div>
                  <div className="col-xl-8 col-lg-8">
                    <div className="it-sv-details-top-content">
                      <h4 className="it-sv-details-title">ECOMMERCE</h4>
                      <p>
                      We have a Magento-based e-commerce system which allows parents of students to place orders for books etc, and handles several thousand orders a day during peak season.<br/>
www.CentralBooksOnline.com
                      </p>
                    </div>
                    <div className="it-feature-button">
                                    <Link className="ed-btn-radius" to="/ecommerceservices">
                                    Know More..
                                    </Link>
                                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="it-sv-details-area pt-30 pb-30">
        <ModalVideo
          channel="youtube"
          isOpen={isOpen}
          videoId="PO_fBTkoznc"
          onClose={() => openModal()}
        />
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <div className="it-sv-details-top-wrap mb-20">
                <div className="row">
                  <div className="col-xl-4 col-lg-4">
                    <div className="it-sv-details-top-thumb">
                      <img src={serviceImg3} alt="" />
                    </div>
                  </div>
                  <div className="col-xl-8 col-lg-8">
                    <div className="it-sv-details-top-content">
                      <h4 className="it-sv-details-title">In-house Customer Support</h4>
                      <p>
                      We have built a software inhouse which will works an self care option for our customers. Here customers will be able to access order status, invoices, statements, payment details etc.,
                      </p>
                    </div>
                    <div className="it-feature-button">
                                    <Link className="ed-btn-radius" to="#">
                                    Know More..
                                    </Link>
                                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterTwo
        footerClass="it-footer-area it-footer-bg it-footer-style-5 ed-footer-style-5 inner-style black-bg pb-70"
        footerLogo={Logo}
        btnClass="it-btn-white sky-bg"
        copyrightTextClass="it-copyright-text inner-style text-center"
      />
    </main>
  );
};
export default ItInfra;
